import { BUTTON_SIZE, DSButton, DSModal } from '@repo/design-system/index'
import { QIcon_caf_MTLD } from '@repo/icons/index'
import { useState } from 'react'
import { s_caf } from '../../../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../../../modules/i18n/useTranslation'

const useMTLDDescriptionPopup = () => {
  const { t } = useTranslation()
  const [showEditPopup, setShowEditPopup] = useState(false)

  const closePopup: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    setShowEditPopup(false)
  }
  const MTLDDescriptionPopup = () => (
    <DSModal id="MTLDDescriptionPopup" isOpen={showEditPopup} setIsOpen={setShowEditPopup} size={'sm'}>
      <DSModal.Title>{t(s_caf.complexity.mtld_modal_title)}</DSModal.Title>
      <DSModal.Content>
        <QIcon_caf_MTLD width={'100%'} height={92} className="mt-[4px]" />
        <div className="mb-[20px] mt-[10px] text-[14px] text-gray-700">{t(s_caf.complexity.mtld_modal_body)}</div>
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton size={BUTTON_SIZE.MD} onClick={closePopup}>
          <DSButton.Label>{t(s_caf.highlight.okay)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )

  return {
    showEditPopup,
    setShowEditPopup,
    MTLDDescriptionPopup,
  }
}

export default useMTLDDescriptionPopup
